export enum DietanamnezType {
  SHORT = 1,
  LONG = 2,
}